import { QueryClient } from "@tanstack/angular-query-experimental";

export const CacheTime = {
	STATIC: { staleTime: 10 * 60 * 1000, gcTime: 30 * 60 * 1000 },
	DYNAMIC: { staleTime: 1 * 60 * 1000, gcTime: 10 * 60 * 1000 },
	LIVE: { staleTime: 10 * 1000, gcTime: 2 * 60 * 1000 },
	NONE: { staleTime: 0, gcTime: 0 },
} as const;

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: CacheTime.DYNAMIC.staleTime,
			gcTime: CacheTime.DYNAMIC.gcTime,
			refetchOnWindowFocus: true,
			refetchOnReconnect: true,
			retry: 3,
			retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
		},
		mutations: {
			retry: 2,
			retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
		},
	},
});
